enum GroupMessageSentStatus {
  PreSent = 'PreSent',
  Success = 'Success',
  Error = 'Error',
}

export default GroupMessageSentStatus;
